import { createSlice } from '@reduxjs/toolkit';

type stateType = {
  name: string;
  userId: number;
  principal: any;
  isMypage: boolean;
  permission: boolean;
};

export const initialState: stateType = {
  name: '',
  userId: 0,
  principal: undefined,
  isMypage: false,
  permission: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthValue: (state, action) => {
      state.name = action.payload;
    },
    setUserIdValue: (state, action) => {
      state.userId = action.payload;
    },
    setPrincipal: (state, action) => {
      state.principal = action.payload;
      // window.localStorage.setItem('principal', JSON.stringify(action.payload));
    },
    setIsMypage: (state, action) => {
      state.isMypage = action.payload;
    },
    setPermission: (state, action) => {
      state.permission = action.payload;
    },
  },
});

export const {
  setAuthValue,
  setUserIdValue,
  setPrincipal,
  setIsMypage,
  setPermission,
} = authSlice.actions;

export default authSlice.reducer;
